import { render } from "./DenseTableDbView.vue?vue&type=template&id=5db1a345&scoped=true"
import script from "./DenseTableDbView.vue?vue&type=script&lang=js"
export * from "./DenseTableDbView.vue?vue&type=script&lang=js"

import "./DenseTableDbView.vue?vue&type=style&index=0&id=5db1a345&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db1a345"]])

export default __exports__